<template>
  <div class="detailBox">
    <!-- 可编辑的基础信息 - 页面头部直接显示 -->
    <div class="baseInfoSection">
      <div class="baseInfoHeader">
        <h3 class="sectionTitle">门票基础信息</h3>
        <el-button
          type="primary"
          @click="onSubmit()"
          :loading="state.saving"
          :icon="Check"
        >
          保存基础信息
        </el-button>
      </div>
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        class="baseInfoForm"
      >
        <div class="formGrid">
          <el-form-item
            label="状态"
            prop="IsQy"
            :rules="[
              { required: true, message: '请选择启用状态', trigger: 'blur' },
            ]"
          >
            <el-switch
              v-model="state.model.IsQy"
              inline-prompt
              active-text="可售"
              inactive-text="停用"
            />
          </el-form-item>
          <el-form-item
            label="供应商"
            prop="GysId"
            :rules="[
              { required: true, message: '请选择供应商', trigger: 'blur' },
            ]"
          >
            <el-select
              v-model="state.model.GysId"
              placeholder="请选择供应商"
              :disabled="!Array.isArray(state.gysData)"
            >
              <el-option
                v-for="item in state.gysData"
                :key="item.Id"
                :label="item.Mc"
                :value="item.Id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="门票名称"
            prop="Mc"
            :rules="[
              { required: true, message: '请输入门票名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.Mc" />
          </el-form-item>
          <el-form-item
            label="景点类型"
            prop="Jdlx"
            :rules="[
              { required: true, message: '请选择景点类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.Jdlx" placeholder="请选择景点类型">
              <el-option label="主题乐园" value="主题乐园" />
              <el-option label="自然景区" value="自然景区" />
              <el-option label="历史古迹" value="历史古迹" />
              <el-option label="博物馆" value="博物馆" />
              <el-option label="动物园" value="动物园" />
              <el-option label="植物园" value="植物园" />
              <el-option label="游乐场" value="游乐场" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="Dh"
            :rules="[
              { required: true, message: '请输入联系电话', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.Dh" />
          </el-form-item>
          <el-form-item label="限购数量" prop="Xgsl">
            <el-input-number
              v-model="state.model.Xgsl"
              :min="0"
              controls-position="right"
              style="width: 100%"
              placeholder="0表示不限"
            />
          </el-form-item>
          <el-form-item label="核销码类型" prop="HeXiaoMaLeiXing">
            <el-select
              v-model="state.model.HeXiaoMaLeiXing"
              placeholder="请选择"
            >
              <el-option label="系统自动码" :value="1" />
              <el-option label="OTA码" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="state.model.HeXiaoMaLeiXing === 2"
            label="OTA商品码"
            prop="SupplierGoodsId"
          >
            <el-input v-model="state.model.SupplierGoodsId" placeholder="OTA商品码" />
          </el-form-item>
          <el-form-item label="地址" class="formItemFull">
            <el-input v-model="state.model.Dz" />
          </el-form-item>
          <el-form-item label="经度" prop="Jd">
            <el-input v-model="state.model.Jd" placeholder="116.404" />
          </el-form-item>
          <el-form-item label="纬度" prop="Wd">
            <el-input v-model="state.model.Wd" placeholder="39.915" />
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="openMapModal()" style="padding: 0; color: #007bff">
              🗺️ 坐标拾取
            </el-button>
          </el-form-item>
          <el-form-item label="开放时间" prop="Kfsj">
            <el-input v-model="state.model.Kfsj" placeholder="08:00-18:00" />
          </el-form-item>
          <el-form-item label="验证方式" class="formItemFull">
            <el-radio-group v-model="state.model.Yzfs">
              <el-radio label="身份证">身份证</el-radio>
              <el-radio label="核销码">核销码</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="formItemGroup">
            <el-form-item label="是否需要预约" class="formItemYuyue">
              <el-switch
                v-model="state.model.IsYuyue"
                inline-prompt
                active-text="是"
                inactive-text="否"
              />
            </el-form-item>
            <el-form-item label="提前预约天数" v-if="state.model.IsYuyue" class="formItemYuyueTianShu">
              <el-input-number
                v-model="state.model.YuyueTianShu"
                :min="1"
                controls-position="right"
                placeholder="需提前N天预约"
              />
            </el-form-item>
          </div>
        </div>

        <div class="formGrid">
          <el-form-item label="年龄段" class="formItemFull">
            <el-checkbox-group v-model="state.model.Ndzcl">
              <el-checkbox label="成人" />
              <el-checkbox label="儿童" />
              <el-checkbox label="老人" />
              <el-checkbox label="学生" />
              <el-checkbox label="军人" />
              <el-checkbox label="残疾人" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="免票政策" class="formItemFull">
            <el-input
              type="textarea"
              v-model="state.model.Mpzc"
              :autosize="{ minRows: 2 }"
              placeholder="例如：1.2米以下儿童免票、70岁以上老人免票等"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- Tab区域：门票简介 + 购票须知 + 门票图片 + 套餐管理 + 销售控制 -->
    <div class="tabSection">
      <el-tabs v-model="state.activeTab" :before-leave="onTabsChange">
        <el-tab-pane lazy label="门票简介" name="jianjie">
          <el-input
            type="textarea"
            v-model="state.model.Jj"
            :autosize="{ minRows: 6 }"
            placeholder="请输入门票简介"
          />
        </el-tab-pane>
        <el-tab-pane lazy label="使用须知" name="xuzhi">
          <div class="notice-editor">
            <!-- 入园说明 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Clock /></el-icon>
                <span>入园说明</span>
              </div>
              <el-input
                type="textarea"
                v-model="notice['入园说明']"
                :autosize="{ minRows: 4 }"
                placeholder="例如：\n• 开放时间：08:00-17:30（16:30停止入园）\n• 入园方式：凭订单二维码或身份证至景区入口闸机处验证入园\n• 同一订单须同时入园，不可分批入园"
              />
            </div>

            <!-- 费用须知 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Wallet /></el-icon>
                <span>费用须知</span>
              </div>
              <el-table :data="notice['费用须知']" border size="small" style="width: 100%">
                <el-table-column label="费用项" width="180">
                  <template #default="scope">
                    <el-input v-model="scope.row['费用项']" placeholder="费用包含/费用不包含" />
                  </template>
                </el-table-column>
                <el-table-column label="费用说明" min-width="300">
                  <template #default="scope">
                    <el-input
                      type="textarea"
                      v-model="scope.row['费用说明']"
                      :autosize="{ minRows: 2 }"
                      placeholder="详细说明费用内容"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 优待政策 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><Avatar /></el-icon>
                <span>优待政策</span>
              </div>
              <el-input
                type="textarea"
                v-model="notice['优待政策']"
                :autosize="{ minRows: 4 }"
                placeholder="例如：\n• 儿童：身高1.2米（含）以下免费\n• 老人：65周岁（含）以上凭有效证件免费\n• 学生：凭学生证半价优惠"
              />
            </div>

            <!-- 其他说明 -->
            <div class="notice-section">
              <div class="notice-section-title">
                <el-icon><InfoFilled /></el-icon>
                <span>其他说明</span>
              </div>
              <el-input
                type="textarea"
                v-model="notice['其他说明']"
                :autosize="{ minRows: 3 }"
                placeholder="例如：\n• 景区禁止携带宠物入园\n• 如遇恶劣天气，部分项目可能暂停开放"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane lazy label="门票图片" name="tupian">
          <el-form-item label="" style="width: 99%; display: flex; align-items: flex-start">
            <draggable
              v-model="state.model.Tps"
              item-key="*"
              animation="200"
              class="tp-drag-wrap"
            >
              <template #item="{ element: tp, index }">
              <div
                :style="{
                  marginTop: '10px',
                  marginRight: '10px',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  position: 'relative',
                  border: state.model.Fm === tp ? '3px solid #409eff' : '3px solid transparent',
                  boxSizing: 'border-box'
                }"
                class="uploadTpBox"
              >
                <el-image class="uploadTp" :src="getImageUrl(tp)" />
                <div style="text-align: center; padding: 8px; background: #f5f7fa;">
                  <el-radio-group
                    v-model="state.model.Fm"
                    style="display: flex; justify-content: center;"
                  >
                    <el-radio :label="tp" size="small">设为封面</el-radio>
                  </el-radio-group>
                </div>
                <div class="uploadDel">
                  <div class="uploadActions">
                    <el-icon size="28" class="actionIcon" @click="onPreviewTp(index)"><View /></el-icon>
                    <el-icon size="28" class="actionIcon" @click="onDelTp(index)"><Delete /></el-icon>
                  </div>
                </div>
              </div>
              </template>
            </draggable>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onUploadChange"
              style="marginLeft: '10px';marginTop: '10px'"
            >
              <template #trigger>
                <div class="uploadAdd" style="margin-top: 10px;">
                  <el-icon size="30" style="margin: auto; cursor: pointer"
                    ><Plus
                  /></el-icon>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <!-- 图片预览 -->
          <el-image-viewer
            v-if="state.preview.show"
            :url-list="state.preview.urlList"
            :initial-index="state.preview.index"
            :teleported="false"
            @close="closePreview"
          />
        </el-tab-pane>
        <el-tab-pane lazy label="套餐管理" name="taocan">
          <c_MenPiaoTcList
            v-if="state.model.Id"
            :key="state.model.Id"
            :spId="state.model.Id"
          />
        </el-tab-pane>
        <el-tab-pane name="gz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              销售控制
            </text>
          </template>
          <c_MenPiaoGzList
            v-if="state.model.Id"
            :spId="state.model.Id"
            :key="state.gzKey"
          />
        </el-tab-pane>
        <el-tab-pane name="lsgz">
          <template #label>
            <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
              历史销控
            </text>
          </template>
          <c_MenPiaoGzOldList
            v-if="state.model.Id"
            :spId="state.model.Id"
            :key="state.lsgzKey"
          ></c_MenPiaoGzOldList>
        </el-tab-pane>
        <el-tab-pane lazy label="评价信息" name="pingjia">
          <div class="pjWrap">
            <!-- 评价统计概览 -->
            <div class="pjSummary" v-if="state.pjSummary.totalCount > 0">
              <div class="pjScoreBox">
                <span class="pjScore">{{ state.pjSummary.avgRating }}</span>
                <span class="pjUnit">/5</span>
                <div class="pjStars">
                  <el-rate
                    v-model="state.pjSummary.avgRating"
                    disabled
                    show-score
                    text-color="#ff9900"
                  />
                </div>
                <span class="pjTotal"
                  >共 {{ state.pjSummary.totalCount }} 条评价</span
                >
              </div>
              <div class="pjDist">
                <div class="pjDistItem" v-for="i in 5" :key="i">
                  <span class="pjDistLabel">{{ 6 - i }}星</span>
                  <el-progress
                    :percentage="getRatingPercent(6 - i)"
                    :show-text="false"
                    :stroke-width="8"
                    color="#f5a623"
                  />
                  <span class="pjDistCount">{{ getRatingCount(6 - i) }}</span>
                </div>
              </div>
            </div>

            <!-- 评价列表 -->
            <div class="pjList">
              <div class="pjItem" v-for="pj in pagedPjList" :key="pj.Id">
                <div class="pjHeader">
                  <span class="pjUser">{{ pj.CjrXm }}</span>
                  <el-rate v-model="pj.Xj" disabled size="small" />
                  <span class="pjTime">{{ formatTime(pj.Cjsj) }}</span>
                </div>
                <div class="pjTags" v-if="pj.PjBq">
                  <el-tag
                    v-for="tag in pj.PjBq.split(',')"
                    :key="tag"
                    size="small"
                    type="info"
                    style="margin-right: 6px"
                    >{{ tag }}</el-tag
                  >
                </div>
                <div class="pjContent">{{ pj.PjNr }}</div>
                <div class="pjImages" v-if="pj.PjTp">
                  <el-image
                    v-for="(img, idx) in pj.PjTp.split(',')"
                    :key="idx"
                    :src="$http.defaults.baseURL + img"
                    :preview-src-list="
                      pj.PjTp.split(',').map((u) => $http.defaults.baseURL + u)
                    "
                    :initial-index="idx"
                    fit="cover"
                    class="pjImg"
                  />
                </div>
                <!-- 商家回复 -->
                <div class="pjReply" v-if="pj.HfNr">
                  <div class="pjReplyHeader">
                    <span class="pjReplyLabel">商家回复</span>
                    <span class="pjReplyTime">{{ formatTime(pj.HfSj) }}</span>
                  </div>
                  <div class="pjReplyContent">{{ pj.HfNr }}</div>
                </div>
              </div>

              <!-- 分页 -->
              <div
                class="pjPagination"
                v-if="state.pjList.length > state.pjPageSize"
              >
                <el-pagination
                  v-model:current-page="state.pjPageIndex"
                  :page-size="state.pjPageSize"
                  :total="state.pjList.length"
                  layout="total, prev, pager, next"
                  background
                  small
                />
              </div>

              <!-- 暂无评价 -->
              <div
                class="pjEmpty"
                v-if="state.pjLoaded && state.pjList.length === 0"
              >
                <el-empty description="暂无评价信息" />
              </div>
            </div>
          </div>
        </el-tab-pane>
        
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, computed } from "vue";
import {
  Clock,
  Wallet,
  Avatar,
  InfoFilled,
  Check,
  Delete,
  Plus,
  View,
} from "@element-plus/icons-vue";
import {
  menpiao_edit,
  menpiao_detail,
  menpiao_tc_list,
  menpiao_uploadtp,
  gongyingshang_select,
  home_uploadconfig,
  shangpinpingjia_getbyspid,
  shangpinpingjia_getsummary,
} from "@/http/api";
import $http from "@/http/index";
import { ElMessage } from "element-plus";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  props: {
    data: Object,
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const state = reactive({
      saving: false,
      activeTab: "jianjie",
      model: {
        IsQy: true,
        Ndzcl: [],
        Jdlx: "",
        Yzfs: "二维码",
        Xgsl: 0,
        Tps: [],
        HeXiaoMaLeiXing: 0,
      },
      tcData: [],
      imageBaseUrl: "", // 图片显示基础URL，根据后端配置决定
      preview: {
        show: false,
        urlList: [],
        index: 0,
      },
      pjList: [],
      pjLoaded: false,
      pjPageIndex: 1,
      pjPageSize: 5,
      pjSummary: {
        totalCount: 0,
        avgRating: 0,
        ratingDistribution: { one: 0, two: 0, three: 0, four: 0, five: 0 },
      },
    });

    const notice = reactive({
      '入园说明': '',
      '费用须知': [
        { '费用项': '费用包含', '费用说明': '' },
        { '费用项': '费用不包含', '费用说明': '' }
      ],
      '优待政策': '',
      '其他说明': ''
    });

    const ticketId = computed(() => props.data?.id);

    //分页后的评价列表
    const pagedPjList = computed(() => {
      const start = (state.pjPageIndex - 1) * state.pjPageSize;
      return state.pjList.slice(start, start + state.pjPageSize);
    });

    onMounted(() => {
      loadUploadConfig();
      loadGys();
      if (ticketId.value) {
        loadDetail();
        onLoadTc();
      }
    });

    onUnmounted(() => {
      // 清理全局 window handler，避免内存泄漏和重复绑定
      delete window.handleMapSelect;
      delete window.closeMapModal;
      if (window.mapModal) {
        window.mapModal.close();
        window.mapModal = null;
      }
    });

    //加载套餐数据
    const onLoadTc = () => {
      menpiao_tc_list(ticketId.value).then((res) => {
        if (res.status == 200) {
          state.tcData = res.data;
        }
      });
    };

    //选项卡切换事件
    const onTabsChange = (value) => {
      if (value == "gz") {
        // 切换前重新加载套餐数据，确保判断准确
        return menpiao_tc_list(ticketId.value).then((res) => {
          if (res.status == 200) {
            state.tcData = res.data;
          }
          if (state.tcData?.length <= 0) {
            ElMessage({
              type: "warning",
              message: "请先添加门票套餐！",
              grouping: true,
            });
            return false;
          }
          state.gzKey = Math.random();
        });
      } else if (value == "lsgz") {
        state.lsgzKey = Math.random();
      } else if (value == "pingjia") {
        state.pjPageIndex = 1;
        loadPingJia();
      }
    };

    //加载门票详情
    // 加载门票详情
    const parseNotice = (gmxz) => {
      if (!gmxz) {
        notice['入园说明'] = '';
        notice['费用须知'] = [
          { '费用项': '费用包含', '费用说明': '' },
          { '费用项': '费用不包含', '费用说明': '' }
        ];
        notice['优待政策'] = '';
        notice['其他说明'] = '';
        return;
      }
      try {
        const data = JSON.parse(gmxz);
        notice['入园说明'] = data['入园说明'] || '';
        notice['费用须知'] = Array.isArray(data['费用须知']) && data['费用须知'].length > 0
          ? data['费用须知']
          : [
              { '费用项': '费用包含', '费用说明': '' },
              { '费用项': '费用不包含', '费用说明': '' }
            ];
        notice['优待政策'] = data['优待政策'] || '';
        notice['其他说明'] = data['其他说明'] || '';
      } catch {
        notice['入园说明'] = gmxz;
        notice['费用须知'] = [
          { '费用项': '费用包含', '费用说明': '' },
          { '费用项': '费用不包含', '费用说明': '' }
        ];
        notice['优待政策'] = '';
        notice['其他说明'] = '';
      }
    };

    const serializeNotice = () => {
      return JSON.stringify({
        '入园说明': notice['入园说明'],
        '费用须知': notice['费用须知'].filter(row => row['费用项'] || row['费用说明']),
        '优待政策': notice['优待政策'],
        '其他说明': notice['其他说明']
      });
    };

    const loadDetail = () => {
      menpiao_detail(ticketId.value).then((res) => {
        if (res.status == 200) {
          state.model = res.data;
          parseNotice(state.model.Gmxz);
          if (typeof state.model.Ndzcl === "string") {
            state.model.Ndzcl = state.model.Ndzcl
              ? state.model.Ndzcl.split(",")
              : [];
          }
        }
      });
    };

    //加载供应商下拉数据
    const loadGys = () => {
      gongyingshang_select().then((res) => {
        if (res.status == 200) state.gysData = res.data;
      });
    };

    //加载上传配置（OSS/本地）
    const loadUploadConfig = () => {
      home_uploadconfig().then((res) => {
        if (res.status == 200) {
          const config = res.data;
          if (config.useOss && config.ossBaseUrl) {
            state.imageBaseUrl = config.ossBaseUrl;
          } else {
            // 本地模式，使用API服务器地址
            state.imageBaseUrl = $http.defaults.baseURL;
          }
        }
      }).catch(() => {
        // 默认使用本地模式
        state.imageBaseUrl = $http.defaults.baseURL;
      });
    };

    //生成图片完整URL
    const getImageUrl = (tp) => {
      if (!tp) return "";
      // OSS返回的是完整URL（以http开头），直接使用
      if (tp.startsWith("http://") || tp.startsWith("https://")) {
        return tp;
      }
      // 本地相对路径，拼接baseUrl
      if (state.imageBaseUrl) {
        return state.imageBaseUrl + tp;
      }
      return $http.defaults.baseURL + tp;
    };

    //保存基础信息
    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.saving = true;
        const submitData = { ...state.model };
        submitData.Gmxz = serializeNotice();
        if (Array.isArray(submitData.Ndzcl)) {
          submitData.Ndzcl = submitData.Ndzcl.join(",");
        }

        menpiao_edit(submitData)
          .then((res) => {
            if (res.status == 200) {
              proxy.$message.success("保存成功");
              loadDetail();
            }
          })
          .finally(() => {
            state.saving = false;
          });
      });
    };

    //上传图片
    const onUploadChange = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      menpiao_uploadtp(formData).then((res) => {
        if (res.status == 200) {
          state.model.Tps = [...state.model.Tps, ...res.data];
          if (!state.model.Fm) state.model.Fm = state.model.Tps[0];
        }
      });
    };

    //删除图片
    const onDelTp = (index) => {
      state.model.Tps.splice(index, 1);
      if (state.model.Fm) {
        if (state.model.Tps?.length > 0) {
          if (!state.model.Tps.includes(state.model.Fm)) {
            state.model.Fm = state.model.Tps[0];
          }
        } else {
          delete state.model.Fm;
        }
      }
    };

    // 图片预览
    const onPreviewTp = (index) => {
      state.preview.urlList = state.model.Tps.map((tp) => getImageUrl(tp));
      state.preview.index = index;
      state.preview.show = true;
    };

    const closePreview = () => {
      state.preview.show = false;
    };

    //打开坐标拾取弹框
    const openMapModal = () => {
      const lng = state.model.Jd || 117.251091;
      const lat = state.model.Wd || 31.517890;
      const url = `/map_picker.html?lng=${lng}&lat=${lat}`;
      
      const modalWidth = 850;
      const modalHeight = 680;
      const left = (window.screen.width - modalWidth) / 2;
      const top = (window.screen.height - modalHeight) / 2;
      
      window.mapModal = window.open(
        url,
        '_blank',
        `width=${modalWidth},height=${modalHeight},left=${left},top=${top},toolbar=no,scrollbars=no,resizable=yes`
      );
      
      window.handleMapSelect = (data) => {
        state.model.Jd = data.lng;
        state.model.Wd = data.lat;
        if (data.address) {
          state.model.Dz = data.address;
        }
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
      
      window.closeMapModal = () => {
        if (window.mapModal) {
          window.mapModal.close();
          window.mapModal = null;
        }
      };
    };

    //加载评价信息
    const loadPingJia = () => {
      if (!ticketId.value) return;
      shangpinpingjia_getbyspid(ticketId.value).then((res) => {
        if (res.status == 200) {
          state.pjList = res.data || [];
          state.pjLoaded = true;
        }
      });
      shangpinpingjia_getsummary(ticketId.value).then((res) => {
        if (res.status == 200) {
          state.pjSummary = res.data;
        }
      });
    };

    //获取指定星级百分比
    const getRatingPercent = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const total = state.pjSummary?.totalCount;
      if (!dist || !total) return 0;
      const map = {
        1: dist.one,
        2: dist.two,
        3: dist.three,
        4: dist.four,
        5: dist.five,
      };
      return Math.round(((map[star] || 0) / total) * 100);
    };

    //获取指定星级数量
    const getRatingCount = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      return map[star] || 0;
    };

    //格式化时间
    const formatTime = (time) => {
      if (!time) return "";
      return new Date(time).toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    return {
      state,
      formDom,
      onSubmit,
      onUploadChange,
      onDelTp,
      onPreviewTp,
      closePreview,
      onTabsChange,
      onLoadTc,
      openMapModal,
      getImageUrl,
      loadUploadConfig,
      pagedPjList,
      loadPingJia,
      getRatingPercent,
      getRatingCount,
      formatTime,
      Check,
      Delete,
      Plus,
      View,
      notice,
      Clock,
      Wallet,
      Avatar,
      InfoFilled,
    };
  },
};
</script>
<style scoped>
/* 图片拖拽排序容器 */
.tp-drag-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.detailBox {
  height: 100%;
  overflow-y: auto;
}

.baseInfoSection {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.baseInfoHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 14px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.baseInfoForm {
  margin-bottom: 0;
}

.formGrid {
  display: flex;
  flex-wrap: wrap;
  gap: 0 16px;
}

.formGrid :deep(.el-form-item) {
  flex: 0 0 calc(33.333% - 11px);
  margin-right: 0;
  margin-bottom: 14px;
}

.formGrid :deep(.el-form-item .el-select),
.formGrid :deep(.el-form-item .el-input),
.formGrid :deep(.el-form-item .el-input-number) {
  width: 100%;
}

.formGrid :deep(.formItemGroup) {
  flex: 0 0 calc(33.333% - 11px);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.formGrid :deep(.formItemGroup .el-form-item) {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.formGrid :deep(.formItemGroup .formItemYuyueTianShu) {
  flex: 1;
}

.formItemFull {
  flex: 0 0 100% !important;
}

.moreCollapse {
  border: none;
}

.moreCollapse :deep(.el-collapse-item__header) {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  color: #909399;
  border: none;
  padding: 0 12px;
}

.moreCollapse :deep(.el-collapse-item__wrap) {
  border: none;
}

.moreCollapse :deep(.el-collapse-item__content) {
  padding: 8px 0 0 0;
}

.tabSection {
  background: #fff;
  border-radius: 8px;
  padding: 0 24px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.tabSection :deep(.el-tabs__header) {
  margin-bottom: 0;
}

.mapContainer {
  height: 480px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  display: flex;
  color: #a2a2a2;
  &:hover {
    background-color: rgba(100, 100, 100, 0.2) !important;
    color: #fff !important;
  }
}

.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  color: #fff;
  display: none;
}
.uploadActions {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 12px;
  box-sizing: border-box;
}
.actionIcon {
  cursor: pointer;
  transition: transform 0.2s;
}
.actionIcon:hover {
  transform: scale(1.15);
}

.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.uploadTpBox:hover .uploadDel {
  display: flex !important;
}

/* ===== 评价信息 ===== */
.pjWrap {
  padding: 10px 0;
}

.pjSummary {
  display: flex;
  gap: 40px;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;
  align-items: center;
}

.pjScoreBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.pjScore {
  font-size: 42px;
  font-weight: 700;
  color: #ff9900;
  line-height: 1;
}

.pjUnit {
  font-size: 18px;
  color: #999;
  margin-bottom: 6px;
}

.pjStars {
  margin: 4px 0;
}

.pjTotal {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}

.pjDist {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pjDistItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pjDistLabel {
  font-size: 13px;
  color: #666;
  width: 30px;
  text-align: right;
}

.pjDistCount {
  font-size: 13px;
  color: #999;
  width: 28px;
}

.pjList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pjItem {
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pjHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pjUser {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pjTime {
  font-size: 12px;
  color: #bbb;
  margin-left: auto;
}

.pjTags {
  margin-bottom: 8px;
}

.pjContent {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pjImages {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.pjImg {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.pjReply {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 8px;
}

.pjReplyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.pjReplyLabel {
  font-size: 12px;
  font-weight: 600;
  color: #409eff;
}

.pjReplyTime {
  font-size: 12px;
  color: #bbb;
}

.pjReplyContent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.pjPagination {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.pjEmpty {
  padding: 40px 0;
}

/* ===== 使用须知编辑器 ===== */
.notice-editor { padding: 16px 8px; }
.notice-section { margin-bottom: 28px; }
.notice-section:last-child { margin-bottom: 0; }
.notice-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.notice-section-title .el-icon { font-size: 18px; color: #409eff; }
</style>
